<template>
  <div class="row format-width">
    <div class="col-12 mb-2">
      <PageTitle title="Relatório clicks no WhatsApp" />  
    </div>

    <div class="col-sm-12 col-md-4 col-lg-5 mt-4">
      <label>Data Início</label>
      <input type="date" class="form-control" v-model="data.dateStart">
    </div>

    <div class="col-sm-12 col-md-4 col-lg-5 mt-4">
      <label>Data Fim</label>
      <input type="date" class="form-control" v-model="data.dateEnd">
    </div>

    <div class="col-sm-12 col-md-2 col-lg-2 mt-4 d-flex flex-column">
      <button
        class="btn btn-success btn-block mt-auto"
        @click="getWhatsAppClick()"
      >
        Filtrar
      </button>
    </div>

    <div class="col-12">
      <div class="row">

        <div class="col-sm-12 col-md-4 col-lg-4 mt-4">
          <b-card title="Tela home">
            <div class="row">
              <div class="col-4 text-center">
                <button class="btn-ads" style="color:#FFF;font-size: 25px;background: #007bff">
                  <i class="fas fa-home"></i>
                </button>
              </div>
              <div class="col-6">
                <h2>{{ dados.count && dados.count.home ? dados.count.home : '0' }}</h2>
              </div>
            </div>
          </b-card>
        </div>

        <div class="col-sm-12 col-md-4 col-lg-4 mt-4">
          <b-card title="Tela do produto">
            <div class="row">
              <div class="col-4 text-center">
                <button class="btn-ads" style="color:#FFF;font-size: 25px;background: #28a745">
                  <i class="fas fa-box-open"></i>
                </button>
              </div>
              <div class="col-6">
                <h2>{{ dados.count && dados.count.product ? dados.count.product : '0' }}</h2>
              </div>
            </div>
          </b-card>
        </div>

        <div class="col-sm-12 col-md-4 col-lg-4 mt-4">
          <b-card title="Tela de contato">
            <div class="row">
              <div class="col-4 text-center">
                <button class="btn-ads" style="color:#FFF;font-size: 25px;background: #ffc107">
                  <i class="fas fa-envelope"></i>
                </button>
              </div>
              <div class="col-6">
                <h2>{{ dados.count && dados.count.contact ? dados.count.contact : '0' }}</h2>
              </div>
            </div>
          </b-card>
        </div>

        <div class="d-flex justify-content-center mb-5" style="width: 100%;" v-if="dados.results">
          <div class="mt-4" style="width: 350px; max-height: 300px; overflow-y: auto;">
            <table class="table table-striped table-bordered">
              <thead>
                <tr>
                  <th>Tela do click</th>
                  <th>Data do click</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, i) in dados.results" :key="i">
                  <td>
                    <span class="badge badge-primary" v-if="item.location == 'home'">
                      Tela home
                    </span>
                    <span class="badge badge-success" v-if="item.location == 'product'">
                      Tela produto
                    </span>
                    <span class="badge badge-warning" v-if="item.location == 'contact'">
                      Tela contato
                    </span>
                  </td>
                  <td>{{item.created_at}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>


      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import makeToast from '@/mixins/makeToast';
import PageTitle from 'Components/PageTitle.vue';
import UserTypes from '@/enums/UserTypes';

export default {
  name: 'ReportWhatsAppClicks',
  mixins: [makeToast],

  components: {
    PageTitle
  },

  data() {
    return {
      dados: [],
      data: {
        dateStart: '',
        dateEnd: ''
      },
    }
  },

  computed: {
    ...mapState(['dadosUsuario']),
  },

  created() {
    this.getWhatsAppClick();
  },

  methods: {
    getWhatsAppClick() {
      this.dados = [];

      const data = {
        dateStart: this.data.dateStart,
        dateEnd: this.data.dateEnd,
        userId: this.userTypeId()
      }

      this.$store.dispatch('startLoader');
      this.$store.dispatch('shopkeeper/getWhatsAppClick', data)
        .then((response) => {
          this.dados = response.data;
        })
        .catch(() => {
          this.makeToast('Ops!', 'Não foi possível buscar os clicks!', 'danger');
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        })
    },
    userTypeId() {
      return this.$route.meta.userType == UserTypes.BALCONISTA
        ? this.dadosUsuario.construp_user_id
        : this.dadosUsuario.id;
    },
  },
}
</script>

<style scoped>
.btn-ads {
  width: 50px;
  height: 50px;
  border-radius: 40px;
  border: none;
}
@media (min-width: 768px) {
.format-width {
  margin-right: 10px;
}
}
</style>

